import { useEffect, useState } from 'react';
import { launchQuery } from '../launches/launches';
import { sanityFetch } from '../services/sanity';
// ---------- FUNCTIONS ----------
export const getNotification = async (config, id) => {
    return sanityFetch(config, `*[
    _type == 'notification'
    && _id == '${id}'
  ][0]${notificationQuery}`);
};
export const getNotificationBySlug = async (config, slug) => {
    return sanityFetch(config, `*[
    _type == 'notification'
    && slug.current == '${slug}'
  ][0]${notificationQuery}`);
};
export const useNotification = (config, slug, _notification, isFocused = true) => {
    const [notification, setNotification] = useState(_notification);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!slug) {
            return;
        }
        if (!notification) {
            setLoading(true);
            getNotificationBySlug(config, slug).then((v) => {
                setNotification(v);
                setLoading(false);
            });
        }
    }, [isFocused, slug]);
    return { notification, loading };
};
// ---------- QUERIES ----------
export const notificationQuery = `{
  _id,
  slug,
  notificationType,
  launch->${launchQuery},
  title,
  subtitle,
  expandedDescription
}`;
//# sourceMappingURL=notifications.js.map